import { Icon } from '../ds';
import { DIAPER_KINDS } from '../lib/labels';

/**
 * The おしっこ / うんち toggle pair — the two are independent, so a change can
 * be both, one, or neither. Shared by the add and edit sheets so the two can
 * never drift apart visually.
 */
export function DiaperToggles({
  pee,
  poop,
  onChange,
}: {
  pee: boolean;
  poop: boolean;
  onChange: (next: { pee: boolean; poop: boolean }) => void;
}) {
  return (
    <div style={{ display: 'flex', gap: 8 }}>
      {DIAPER_KINDS.map((kind) => {
        const on = kind.key === 'pee' ? pee : poop;
        const toggle = () =>
          onChange(kind.key === 'pee' ? { pee: !on, poop } : { pee, poop: !on });
        const tone =
          kind.accent === 'sky'
            ? {
                bg: 'var(--sky-100)',
                border: 'var(--sky-400)',
                chip: 'var(--sky-500)',
                text: 'var(--sky-700)',
              }
            : {
                bg: 'var(--warning-subtle)',
                border: 'var(--amber-500)',
                chip: 'var(--amber-500)',
                text: 'var(--amber-700)',
              };
        return (
          <button
            key={kind.key}
            type="button"
            aria-pressed={on}
            onClick={toggle}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 9,
              padding: '12px 13px',
              borderRadius: 'var(--radius-md)',
              cursor: 'pointer',
              border: `1.5px solid ${on ? tone.border : 'var(--border)'}`,
              background: on ? tone.bg : 'var(--surface)',
              transition: 'all .16s var(--ease-standard)',
            }}
          >
            <span
              style={{
                flex: 'none',
                width: 30,
                height: 30,
                borderRadius: '50%',
                background: on ? tone.chip : 'var(--surface-sunken)',
                color: on ? '#fff' : 'var(--text-subtle)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon name={kind.icon} size={16} />
            </span>
            <span style={{ flex: 1, textAlign: 'left' }}>
              <span
                style={{
                  display: 'block',
                  fontWeight: 700,
                  fontSize: 'var(--text-sm)',
                  color: on ? tone.text : 'var(--text-muted)',
                }}
              >
                {kind.label}
              </span>
              <span style={{ display: 'block', fontSize: 10, color: 'var(--text-subtle)' }}>
                {kind.labelEn}
              </span>
            </span>
            {on ? (
              <span style={{ color: tone.text }}>
                <Icon name="Check" size={18} />
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
